import * as t from 'io-ts';

import {
  defaultLastWriterWinsValue,
  mergeLastWriterWinsValue,
  RLastWriterWinsValue,
} from './lastWriterWinsValue';

/*
 * Constants.
 */

export enum ActivationPopoversEnum {
  LIVE_DASHBOARD_SUGGESTION = 'liveDashboardSuggestion',
  ENABLE_AI_COPILOT_SUGGESTION = 'enableAiCopilotSuggestion',
  CONFIGURE_AI_WORKSPACE_SETTINGS_SUGGESTION = 'configureAiWorkspaceSettingsSuggestion',
  CONFIGURE_AI_COPILOT_KNOWLEDGE_BASE_SUGGESTION = 'configureAiCopilotKnowledgeBaseSuggestion',
  DISCARD_SUGGESTED_REPLY_KNOWLEDGE_BASE_SUGGESTION = 'discardSuggestedReplyKnowledgeBaseSuggestion',
  ENABLE_AI_SLACK_INBOXES_SUGGESTION = 'enableAiSlackInboxesSuggestion',
}

/*
 * Runtime types.
 */

const RPopoverNamespaceContext = t.type({
  namespace: t.string,
});

const RPopoverKnowledgeBaseContext = t.intersection([
  RPopoverNamespaceContext,
  t.type({
    knowledgeBaseName: t.string,
  }),
]);

const RActivationPopovers = t.partial({
  [ActivationPopoversEnum.LIVE_DASHBOARD_SUGGESTION]: RPopoverNamespaceContext,
  [ActivationPopoversEnum.ENABLE_AI_COPILOT_SUGGESTION]: RPopoverNamespaceContext,
  [ActivationPopoversEnum.CONFIGURE_AI_WORKSPACE_SETTINGS_SUGGESTION]: RPopoverNamespaceContext,
  [ActivationPopoversEnum.CONFIGURE_AI_COPILOT_KNOWLEDGE_BASE_SUGGESTION]: RPopoverKnowledgeBaseContext,
  [ActivationPopoversEnum.DISCARD_SUGGESTED_REPLY_KNOWLEDGE_BASE_SUGGESTION]: RPopoverKnowledgeBaseContext,
  [ActivationPopoversEnum.ENABLE_AI_SLACK_INBOXES_SUGGESTION]: RPopoverNamespaceContext,
});

export type ActivationPopovers = t.TypeOf<typeof RActivationPopovers>;

export const RLastWriterWinsActivationPopovers = t.intersection([
  RLastWriterWinsValue,
  t.type({
    popovers: RActivationPopovers,
  }),
]);

type LastWriterWinsActivationPopovers = t.TypeOf<typeof RLastWriterWinsActivationPopovers>;

/*
 * Default.
 */

export const defaultActivationPopovers: LastWriterWinsActivationPopovers = {
  ...defaultLastWriterWinsValue,
  popovers: {},
};

/*
 * Merge strategy.
 */

export function mergeActivationPopovers(
  left: LastWriterWinsActivationPopovers,
  right: LastWriterWinsActivationPopovers,
): LastWriterWinsActivationPopovers {
  return mergeLastWriterWinsValue(left, right);
}
